const Current = ({currentStep}: {currentStep: number}) => (
    <div className="rounded-full bg-radio-selected-border h-28 w-28 flex justify-center items-center">
      <p className="text-white font-semibold text-t18 h-24">{currentStep}</p>
    </div>
  );

  export {Current}